import FormGroup, { FormGroupType } from './FormGroup';

export { FormGroupType };
export default FormGroup;
